






















































const name = 'PerfNotificationBody';
import { NotiActionType, NotiFromType } from './../../../const/notification';
import { defineComponent, ref } from '@vue/composition-api';
import { useNotification } from './hooks/index';
import BytedIconDoubleDown from '@byte-design/vue-icons/icons/DoubleDown';
import BytedIconDoubleUp from '@byte-design/vue-icons/icons/DoubleUp';

export default defineComponent({
	name,
	components: { BytedIconDoubleDown, BytedIconDoubleUp },
	props: {
		noti: {
			type: Object,
			required: true
		},
		showMore: {
			type: Boolean,
			required: true
		},
		from: {
			type: String,
			default: NotiFromType.notification
		},
		currency: {
			type: String,
			required: false,
		}
	},
	setup(){
    const { getProperTranslation, gotoNewBilling, handleRedirect } = useNotification();
		const ifMore = ref(true); // Expand & Collapse copywriting in banner

		function expandAndCollapse() {
      ifMore.value = !ifMore.value
    }
		return {
			NotiActionType,
			gotoNewBilling,
			ifMore,
			expandAndCollapse,
			handleRedirect,
			getProperTranslation,
		}
	}
})
